import { Children, cloneElement, forwardRef, isValidElement, useId } from 'react'
import './fields.css'

const FieldLabel = forwardRef(function FieldLabel({ children, className = '', required, hint, choice = false, htmlFor, ...props }, ref) {
    const generatedId = useId()
    const items = Children.toArray(children)
    const field = items.find(child => isValidElement(child) && child.type?.uiField)
    const target = htmlFor || field?.props.id || (field ? generatedId : undefined)
    const labelId = generatedId + '-label'
    const labelContent = items.filter(child => child !== field)
    const text = <span className="uiLabelText" id={labelId}>{labelContent}{required && <span className="uiRequired" aria-hidden="true">*</span>}{hint && <span className="uiFieldHint">{hint}</span>}</span>
    const control = field && cloneElement(field, { id: target, 'aria-labelledby': field.props['aria-labelledby'] || (field.props['aria-label'] ? undefined : labelId) })
    return <label {...props} ref={ref} htmlFor={target} className={['uiFieldLabel', choice ? 'uiChoiceLabel' : '', field ? 'uiFieldLabel--wrap' : '', className].filter(Boolean).join(' ')}>
        {field ? (items.indexOf(field) === 0 ? <>{control}{text}</> : <>{text}{control}</>) : <>{children}{required && <span className="uiRequired" aria-hidden="true">*</span>}{hint && <span className="uiFieldHint">{hint}</span>}</>}
    </label>
})

export default FieldLabel
